<template>
    <div>
        <v-layout justify-space-between align-center mb-4>
            <v-btn-toggle v-model="rolesTabs" style="background: transparent">
                <v-btn flat @click="rolesWithUsers">Roles with Users</v-btn>
                <v-btn flat @click="rolesWithUsersAndPermissions">Roles with Users and Permissions</v-btn>
            </v-btn-toggle>
        </v-layout>

        <v-card  class="rounded-box" flat>
            <v-card-title class="pt-0">
                Roles
                <v-spacer></v-spacer>
                <vue-excel-xlsx
                    class="v-btn v-btn--round theme--light primary"
                    :data="data"
                    :columns="exportData.columns"
                    :file-name="exportData.fileName"
                    :file-type="exportData.fileType"
                    :sheet-name="exportData.sheetName"
                    >
                    {{ rolesTabs == 0 ? 'Download Roles With Users' : 'Download Roles With Users and Permissions' }}
                </vue-excel-xlsx>
            </v-card-title>
            
            <v-data-table :headers="headers" :key="`t-${rolesTabs}`" :items="data" :item-key="`${rolesTabs === 0 ? 'id.user_name' : 'users'}`" :search="search" :loading="isLoading">
                <template v-slot:items="{ item }">
                    <td>{{ item.name }}</td>
                    <td>{{ item.description }}</td>
                    <td style="white-space: pre-line;" v-if="item.users">{{ item.permissions }}</td>
                    <td>{{ item.user_name || item.users }}</td>
                </template>
            </v-data-table>
        </v-card>
    </div>

</template>
<script>

export default {
    components: {
 
    },
    data() {
        return {
            rolesTabs: 0,
            search: '',
            headers: [
                { text: 'Name', value: 'name' },
                { text: 'Description', value: 'description' },
                { text: 'User Name', value: 'user_name' }
            ],
            data: [],
            exportData:{
                columns: [],
                fileName: 'fileName',
                fileType: 'xlsx',
                sheetName: 'fileName'
            }
        }
    },
    mounted() {
        this.$store.dispatch('fetchRolesWithUsers')
        setTimeout(() => {
            this.rolesWithUsers()
        }, 1000)
    },
    watch: {
        isLoading(val) {
            if(!val){
                this.rolesWithUsers()
            }
        }
    },
    computed: {
        allRoles() {
            return this.$store.state.user.rolesWithUsers;
        },
        isLoading() {
            return this.$store.state.user.rolesLoading;
        }
    },
    methods: {
        rolesWithUsers() {
            this.data = this.allRoles;
            this.headers = [
                { text: 'Name', value: 'name' },
                { text: 'Description', value: 'description' },
                { text: 'User Name', value: 'user_name' }
            ]
            this.exportData.columns =  [
                { label: 'Role Name', field: 'name' },
                { label: 'Role Description', field: 'description' },
                { label: 'User Name', field: 'user_name' }
            ]
            this.exportData.fileName = 'Roles_With_Users'
            this.exportData.sheetName = 'Roles Report'
        },
        rolesWithUsersAndPermissions() {
            let uniqueRoles = {};
            this.allRoles.forEach(i => {
                let permissions = []
                //loop through the permissions permission is object has key and array value
                for (let key in i.permissions) {
                    if(i.permissions[key].length > 0){
                        permissions.push(key + ': ' + i.permissions[key].join(', '))
                    }
                }
                if(!uniqueRoles[i.name]){
                    uniqueRoles[i.name] = {
                        name: i.name,
                        description: i.description,
                        permissions: permissions.join(', \n'),
                        users: [
                            {
                                id: i.id,
                                user_name: i.user_name,
                                // email: i.email
                            }
                        ]
                    }

                }else{
                    uniqueRoles[i.name].users.push({
                        id: i.id,
                        user_name: i.user_name,
                        // email: i.email
                    })
                }
                
            });
            this.data = Object.values(uniqueRoles).map(i => {
                i.users = i.users.map(u => Object.values(u).join(', ')).join(', \n')
                return i
            
            });
            this.headers = [
                { text: 'Name', value: 'name' },
                { text: 'Description', value: 'description' },
                { text: 'Permissions', value: 'permissions' },
                { text: 'Users', value: 'users' }
            ]
            this.exportData.columns =  [
                { label: 'Role Name', field: 'name' },
                { label: 'Role Description', field: 'description' },
                { label: 'Permissions', field: 'permissions' },
                { label: 'Users', field: 'users' }
            ]
            this.exportData.fileName = 'Roles_With_Users_And_Permissions'
            this.exportData.sheetName = 'Roles Report'
        },
        
    }

}

</script>